import React from 'react';
import userData from '../data/data';
import AboutImg from '../img/aboutImg.png';
import Fade from 'react-reveal/Fade';

const About = () => {
  return (
    <div id='about' className="relative bg-white flex flex-col text-center md:text-left md:flex-row px-10 justify-evenly mx-auto items-center snap-center">
        <h3 className='absolute top-20 uppercase tracking-[20px] text-gray-500 text-2xl text-center 
            flex flex-col md:text-left md:flex-row px-10 justify-evenly mx-auto items-center'>
            About
        </h3>
        <img
            src={AboutImg}
            alt="about"
            className='about-img mt-40 md:mb-0 flex-shrink-0 rounded-full object-cover md:rounded-lg md:w-64 md:h-95 xl:w-[600px] xl:h-[600px]'  
        />
        <Fade bottom>
        <div className='space-y-10 px-0 md:px-10'>
            <div className="text-4xl font-bold pt-10">{userData.about.header}</div>
            <div className='text-gray-500'>
                {userData.about.description?.map((desc, idx) => (
                    <p 
                        key={idx} 
                        className='about-desc text-xl text-gray-700 mb-4 dark:text-gray-300'>
                        {desc}
                    </p>
                ))}
            </div>
        </div>
        </Fade>
    </div>
  )
}

export default About;